module.exports = __webpack_public_path__ + "media/images/help/line/heading-point-2-6b93cf7c5f88f30655c45b0c0d929a36.svg";